import { createFileRoute } from "@tanstack/react-router";

import { SidebarCollapsedTrigger } from "../components/ui/sidebar";

function OperatorsIndexRouteView() {
  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col bg-background text-muted-foreground/40">
      <header className="border-b border-border px-3 py-2">
        <div className="flex items-center gap-2">
          <SidebarCollapsedTrigger className="size-7 shrink-0" />
          <span className="text-sm font-medium text-foreground">Threads</span>
        </div>
      </header>

      <div className="flex flex-1 items-center justify-center">
        <div className="text-center">
          <p className="text-sm">Select a thread or create a new one to get started.</p>
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/_app/operators/")({
  component: OperatorsIndexRouteView,
});
